/**
 * Hooks de carga para el módulo Flota.
 */
import { useQuery } from '@tanstack/react-query';
import { API_BASE, getAuthHeaders, getEmpresaId } from './format';

async function jsonFetch(url) {
  const r = await fetch(url, { headers: getAuthHeaders() });
  if (!r.ok) throw new Error(`HTTP ${r.status}`);
  return r.json();
}

export function useMantenimientos() {
  const empresaId = getEmpresaId();
  const q = useQuery({
    queryKey: ['flota', 'mantenimientos', empresaId],
    queryFn: () => jsonFetch(`${API_BASE}/turismo/mantenimiento/mantenimientos?empresa_id=${empresaId}`),
    staleTime: 30 * 1000,
  });
  return { ...q, mantenimientos: q.data || [] };
}

export function usePlantillas() {
  const empresaId = getEmpresaId();
  const q = useQuery({
    queryKey: ['flota', 'plantillas', empresaId],
    queryFn: () => jsonFetch(`${API_BASE}/turismo/mantenimiento/plantillas?empresa_id=${empresaId}&solo_activas=false`),
    staleTime: 60 * 1000,
  });
  return { ...q, plantillas: q.data || [] };
}

export function useKpisFlota() {
  const empresaId = getEmpresaId();
  return useQuery({
    queryKey: ['flota', 'kpis', empresaId],
    queryFn: () => jsonFetch(`${API_BASE}/turismo/mantenimiento/kpis?empresa_id=${empresaId}`),
    staleTime: 60 * 1000,
  });
}

export function useEmbarcaciones() {
  const empresaId = getEmpresaId();
  const q = useQuery({
    queryKey: ['flota', 'embarcaciones', empresaId],
    queryFn: () => jsonFetch(`${API_BASE}/turismo/embarcaciones?empresa_id=${empresaId}&solo_activas=false`),
    staleTime: 5 * 60 * 1000,
  });
  return { ...q, embarcaciones: q.data || [] };
}

/** Particiona mantenimientos por estado. */
export function categorizar(mantenimientos = []) {
  return {
    proximos:   mantenimientos.filter(m => m.estado === 'programado'),
    enCurso:    mantenimientos.filter(m => m.estado === 'en_curso'),
    completados: mantenimientos.filter(m => m.estado === 'completado' || m.estado === 'saltado'),
    vencidos:   mantenimientos.filter(m => m.estado === 'vencido'),
  };
}
